import { render, staticRenderFns } from "./costosReconocimientoFacial.vue?vue&type=template&id=f92eff48&scoped=true"
import script from "./costosReconocimientoFacial.vue?vue&type=script&lang=js"
export * from "./costosReconocimientoFacial.vue?vue&type=script&lang=js"
import style0 from "./costosReconocimientoFacial.vue?vue&type=style&index=0&id=f92eff48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f92eff48",
  null
  
)

export default component.exports